import { Navigate } from "react-router-dom"
import {
  DiMaDetailsContent,
  DiMaDetailsContentProps,
} from "../../../../../../components/DiMaDetailsContent"
import { ApplicationPermissionPut } from "../../../../../../models/ApplicationPermission"
import { ApplicationRolePermissionDetailGet } from "../../../../../../models/ApplicationRolePermission"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../../../../models/Authorization"
import { UserInfo } from "../../../../../../models/User"

export function ApplicationRolePermissionDetails(props: {
  readonly applicationRolePermission: ApplicationRolePermissionDetailGet
  readonly user: UserInfo
}) {
  const { applicationRolePermission, user } = props
  const returnURL = `/applications/${applicationRolePermission.application.id}/roles/${applicationRolePermission.role.id}#permissions`

  if (!applicationRolePermission) {
    return <Navigate to={returnURL} />
  }

  const detailsContentProps: DiMaDetailsContentProps<ApplicationPermissionPut> = {
    canWrite: hasUserAccessToApplicationFeature(
      user.authorizations.applications,
      applicationRolePermission.application.id,
      DimaFeatureShortNameEnum.AM,
      AccessLevel.Write
    ),
    listItems: [
      {
        id: 0,
        label: "Application",
        displayItem: (
          <div style={{ width: "100%" }}>
            {applicationRolePermission.application.name}
          </div>
        ),
      },
      {
        id: 1,
        label: "Role",
        displayItem: (
          <div style={{ width: "100%" }}>{applicationRolePermission.role.name}</div>
        ),
      },
      {
        id: 2,
        label: "Name",
        displayItem: (
          <div style={{ width: "100%" }}>{applicationRolePermission.permission.name}</div>
        ),
      },
      {
        id: 3,
        label: "Description",
        displayItem: (
          <div style={{ width: "100%" }}>
            {applicationRolePermission.permission.description}
          </div>
        ),
      },
    ],
  }

  return <DiMaDetailsContent {...detailsContentProps} />
}
